import Loading from 'components/Gui/Loading';
import { baseConfigClient } from 'constants/baseConfigClient';
import _ from 'lodash';
import React, { useState, useEffect, useCallback } from 'react';
import { getConfigurationClient, getConfigurationTenant  } from 'services';  //getTemplates

const ConfigContext = React.createContext();
const ConfigContextConsumer = ConfigContext.Consumer;

const ConfigContextProvider = ({children}) => {
	const [currentConfigClient, setCurrentConfigClient] = useState(null);
	const [isFetchingClient, setIsFetchingClient] = useState(true);
	const [currentConfigTenant, setCurrentConfigTenant] = useState(null);
	const [isFetchingTenant, setIsFetchingTenant] = useState(true);
    const [appliedDepartmentId, setAppliedDepartmentId] = useState(null);

    const customizer = (objValue, srcValue) => {
        //if obj is array, keep only the srcValue
        if (_.isArray(objValue)) {
            return srcValue
        }
    }

    const getConfClient = async () => {
		setIsFetchingClient(true)
		const response = await getConfigurationClient()
        let mergedConfigurationClient = { ...baseConfigClient }
        if (response.data) {
            mergedConfigurationClient = _.mergeWith(mergedConfigurationClient, response.data, customizer)
        }

        setCurrentConfigClient(mergedConfigurationClient)
		setIsFetchingClient(false)
	}

	const getConfTenant = async () => {
		setIsFetchingTenant(true)
		const response = await getConfigurationTenant()
		setCurrentConfigTenant(response.data)
		setIsFetchingTenant(false)
	}

    // Applica gli override del dipartimento alla configurazione
    const applyDepartmentOverrides = useCallback((departmentId) => {
        if (!departmentId || !currentConfigClient) return;

        // Evita di riapplicare gli override per lo stesso dipartimento
        if (appliedDepartmentId === departmentId) return;

        const { departmentsOverrides, ...baseConfig } = currentConfigClient;

        if (!departmentsOverrides || !Array.isArray(departmentsOverrides)) return;

        const departmentOverride = departmentsOverrides.find(
            d => Array.isArray(d.departmentId)
                ? d.departmentId.includes(departmentId)
                : d.departmentId === departmentId
        );

        if (departmentOverride && departmentOverride.overrides) {
            const mergedConfig = _.mergeWith(
                { ...baseConfig },
                departmentOverride.overrides,
                customizer
            );
            // Mantieni departmentsOverrides per riferimento futuro
            mergedConfig.departmentsOverrides = departmentsOverrides;
            setAppliedDepartmentId(departmentId);
            setCurrentConfigClient(mergedConfig);
        }
    }, [currentConfigClient, appliedDepartmentId]);

	useEffect(() => {
		if (!currentConfigClient) {
			getConfClient()
		}
		if (!currentConfigTenant) {
			getConfTenant()
		}
	}, []);


	if (isFetchingClient || isFetchingTenant) {
		return (
			<Loading fullpage />
		)
	} else {
		return (
            <ConfigContext.Provider value={{
                tenantConfig: currentConfigTenant,
                clientConfig: currentConfigClient,
                applyDepartmentOverrides
            }}>
				{children}
			</ConfigContext.Provider>
		)
	}
}

export { ConfigContext, ConfigContextProvider, ConfigContextConsumer };

